import { type RefObject, useLayoutEffect, useState } from 'react';

/**
 * 요소의 너비(px)를 잰다. 그래프는 놓이는 자리를 채우고(규격 §2), 1px 선과 글자 크기가 늘어나지 않도록
 * viewBox 로 늘리지 않고 잰 너비로 다시 그린다. ResizeObserver 가 없는 환경(테스트)은 `fallback` 그대로.
 */
export function useElementWidth(ref: RefObject<HTMLElement | null>, fallback: number): number {
  const [width, setWidth] = useState(fallback);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return;
    const measure = () => {
      const next = Math.floor(element.getBoundingClientRect().width);
      if (next > 0) setWidth(next);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);
  return width;
}
